import { useId } from 'react';
import type { FormSelectProps } from './interfaces';

export function useSelect({
  id,
  error,
  message,
  validation,
  onChange,
}: FormSelectProps) {
  const uid = useId();
  const inputId = id ?? `select-${uid}`;

  const finalMessage = error ?? message;
  const finalValidation: FormSelectProps['validation'] = error ? 'error' : validation;

  const handleChange: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
    onChange?.(e, e.target.value);
  };

  return { inputId, finalMessage, finalValidation, handleChange };
}
